import React, {ReactElement, ReactNode} from 'react';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../constants';

export const WrapWithDiv = ({className, children}: {className: string; children: ReactNode}) => {
  const {experiments} = useExperiments();

  return experiments.enabled(SPECS.ecomCheckoutBrandStyling) ? (
    <div className={className}>{children}</div>
  ) : (
    (children as ReactElement)
  );
};
